import React, { Component, Fragment } from 'react';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';

export default class WasteCleared extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row">
                <div className="form-group col-md-4">
                    <FormInputNumber
                        type="number"
                        name="total_waste_removed"
                        label="Total waste removed as shown on WTN"
                        value={this.props.total_waste_removed}
                        classes={
                            this.props.errors.total_waste_removed ? 'form-control is-invalid' : 'form-control'
                        }
                        error={this.props.errors.total_waste_removed}
                        handleChange={this.props.handleTotalWasteChange}
                        step={1}
                        min={0}
                    />
                </div>
                <div className="form-group col-md-4 hidden">
                    <FormInputNumber
                        type="number"
                        name="provider_total_waste_removed"
                        label="Provider total waste removed"
                        value={this.props.provider_total_waste_removed}
                        classes={
                            this.props.errors.provider_total_waste_removed ? 'form-control is-invalid' : 'form-control'
                        }
                        error={this.props.errors.provider_total_waste_removed}
                        handleChange={this.props.handleTotalWasteChange}
                        step={1}
                        min={0}
                    />
                </div>
                <div className="form-group col-md-4">
                    <FormInputNumber
                        type="number"
                        name="estimate_waste_removed"
                        label="Estimated total waste removed (kg)"
                        value={this.props.estimate_waste_removed || 0}
                        classes={this.props.errors.estimate_waste_removed ? 'form-control is-invalid' : 'form-control'}
                        error={this.props.errors.estimate_waste_removed}
                        handleChange={this.props.handleChange}
                        step={1}
                        min={0}
                    />
                </div>
            </div>
        );
    }
}
